<!--
 * @Author: your name
 * @Date: 2021-01-27 10:10:31
 * @LastEditTime: 2022-11-02 09:27:24
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/product-detail/component/MutipleSize/index.vue
-->
<style scoped lang="sass">
.app_container
  margin-bottom: 17PX

.item
  display: flex
  justify-content: space-between
  align-items: center
  width: 100%
  height: 50PX
  padding: 0 10PX
  border: 1PX solid var(--menu-primary-background-colour)
  border-radius: 5PX
  color: var(--menu-primary-background-colour)
  margin-bottom: 10PX

  &:last-child
    margin-bottom: 0

.choosed
  color: #fff
  background: var(--menu-primary-background-colour)

.hide
    display: none

.name
  font-size: 14px

.price
  font-size: 14px
</style>

<template lang="pug">
.app_container
  .item.p(
    v-for="(item, index) in itemList"
    :class="{'choosed': index === choosedIndex, 'hide': index !== choosedIndex && filterOtherOption}"
    @click="chooseItem(index, item)"
  )
    .name {{ getLocalizedSizeName(item) }}
    .price.ls1 {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ formatPrice(item.price) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { convertPrice, formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import { getLocalizedField } from '@/utils/language'

@Component({
  computed: {
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    },
    // Track currentCurrency to force re-render on currency change
    // 跟踪 currentCurrency 以在货币切换时强制重新渲染
    currentCurrency() {
      return this.$store.state.currencySettings?.currentCurrency || 'AUD'
    },
    // Track currentLanguage for reactive localization / 跟踪当前语言以响应式更新
    currentLanguage() {
      return this.$store.state.language?.currentLanguage
    },
  },

  mounted() {
    const defaultItem = this.itemList.find(item => item.default)
    // console.log('defaultItem', defaultItem)
    if (defaultItem && this.choosedIndex === -1) this.choosedIndex = defaultItem.index
  },

  props: {
    itemList: {
      type: Array
    },
    filterOtherOption: Boolean
  }
})

class MutipleSize extends Vue {
  choosedIndex = -1

  // Get localized size name / 获取本地化的尺寸名称
  getLocalizedSizeName(item) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(item, 'name') || item.name
  }

  // Format price with currency conversion / 格式化价格（带货币转换）
  formatPrice(val) {
    const _currency = this.currentCurrency // eslint-disable-line no-unused-vars
    const price = typeof val === 'number' ? val : parseFloat(val)
    if (isNaN(price)) return val
    return formatDecimalNumber(convertPrice(price))
  }

  chooseItem(index, item) {
    this.choosedIndex = index
    this.$emit('choosedItem', item)
  }

  /**
   * Set choosedIndex
   * @param index {Number} The value to be assigned to choosedIndex
   */
  /**
   * 设置 choosedIndex
   * @param index {Number} 要赋值给 choosedIndex 的值
   */
  _setChoosedIndex(index) {
    this.choosedIndex = index
    this.$emit('choosedItem', this.itemList[index])
  }
}

export default MutipleSize
</script>
